import {interpolate, spring, useVideoConfig} from 'remotion';
import {fontFamily, theme} from '../theme';

const numberFormatter = new Intl.NumberFormat('zh-CN');

type MetricHeaderProps = {
  frame: number;
  dateLabel: string;
  sessions: number;
  minutes: number;
  averageSessions: number;
  averageMinutes: number;
  outroProgress: number;
};

const Metric = ({
  accent,
  label,
  value,
  unit,
  average,
}: {
  accent: string;
  label: string;
  value: number;
  unit: string;
  average: string;
}) => {
  return (
    <div style={{width: 540, textAlign: 'center'}}>
      <div
        style={{
          color: theme.text,
          fontFamily,
          fontSize: 74,
          fontWeight: 650,
          letterSpacing: -2,
          lineHeight: 1,
          textShadow: `0 0 28px ${accent}45`,
        }}
      >
        {numberFormatter.format(Math.round(value))}
        <span style={{fontSize: 26, fontWeight: 500, marginLeft: 12, color: theme.text}}>{unit}</span>
      </div>
      <div
        style={{
          height: 2,
          margin: '18px auto 13px',
          width: 340,
          background: `linear-gradient(90deg, transparent, ${accent}, transparent)`,
          boxShadow: `0 0 15px ${accent}`,
        }}
      />
      <div style={{fontFamily, fontSize: 24, fontWeight: 500, color: accent, letterSpacing: 1.5}}>
        {label}
      </div>
      <div style={{fontFamily, fontSize: 17, color: theme.muted, marginTop: 7}}>{average}</div>
    </div>
  );
};

export const MetricHeader = ({
  frame,
  dateLabel,
  sessions,
  minutes,
  averageSessions,
  averageMinutes,
  outroProgress,
}: MetricHeaderProps) => {
  const {fps} = useVideoConfig();
  const entrance = spring({frame: frame - 120, fps, config: {damping: 18, stiffness: 90}});
  const opacity = interpolate(entrance, [0, 1], [0, 1]);
  const translateY = interpolate(entrance, [0, 1], [24, 0]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 44,
        left: 96,
        right: 96,
        opacity,
        transform: `translateY(${translateY}px)`,
      }}
    >
      <div
        style={{
          textAlign: 'center',
          color: theme.text,
          fontFamily,
          fontSize: 25,
          fontWeight: 520,
          letterSpacing: 2.5,
        }}
      >
        {dateLabel.replace('-', ' — ')}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          gap: 170,
          marginTop: 30,
        }}
      >
        <Metric
          accent={theme.sessions}
          label={outroProgress > 0.5 ? '累计工作会话' : '工作会话次数'}
          value={sessions}
          unit="次"
          average={`周均 ${numberFormatter.format(Math.round(averageSessions))} 次`}
        />
        <Metric
          accent={theme.minutes}
          label={outroProgress > 0.5 ? '累计花费时间' : '花费时间'}
          value={minutes}
          unit="分钟"
          average={`周均 ${numberFormatter.format(Math.round(averageMinutes))} 分钟`}
        />
      </div>
    </div>
  );
};
